import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { faPencil, faTrash } from '@fortawesome/pro-light-svg-icons';
import { EmergencyContactModalComponent } from './emergency-contact-modal/emergency-contact-modal.component';
import { EmergencyContact } from '@app/core/types/membership/membership.types';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'c-emergency-contact',
    templateUrl: './emergency-contact.component.html',
    styleUrls: ['./emergency-contact.component.scss'],
    standalone: false
})
export class EmergencyContactComponent {
  @Input() form: FormGroup;
  @Input() loading: boolean;

  pencilIcon = faPencil;
  trashIcon = faTrash;
  plusIcon = faPlus;

  @Output() submitForm: EventEmitter<void> = new EventEmitter<void>();

  get fullName(): string {
    const { firstName, lastName } = this.form.value;
    return `${firstName} ${lastName}`;
  }

  constructor(public modalController: ModalController) {}

  get hasContact(): boolean {
    const { firstName, lastName, phoneNumber } = this.form.value;
    return !!firstName && !!lastName && !!phoneNumber;
  }

  async initModal(): Promise<void> {
    const emergencyContact = this.hasContact ? this.form.value : null;

    const modal = await this.modalController.create({
      component: EmergencyContactModalComponent,
      cssClass: 'emergency-contact-modal',
      componentProps: {
        close: () => modal.dismiss(),
        onSave: (emergencyContact: EmergencyContact) => this.setContactDetails(emergencyContact),
        emergencyContact,
      },
    });

    await modal.present();
  }

  clearContact() {
    this.setContactDetails({
      firstName: '',
      lastName: '',
      phoneNumber: '',
    });
  }

  setContactDetails(objContactDetails: EmergencyContact) {
    this.form.setValue(objContactDetails);
  }

  /**
   * Submit form
   */
  submit() {
    this.submitForm.emit(this.form?.value);
  }
}
